module.exports = __webpack_public_path__ + "img/1.0f35eb30.png";